












































import { COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND, COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND_DARK, COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { Vue, Component, Prop, Model } from "vue-property-decorator";

@Component
export default class MenuIconWithSelectionListComponent<T> extends Vue {
  @Prop({ default: "mdi-sort-alphabetical-variant" })
  iconResource!: string;

  @Prop({ default: "white" })
  iconColor!: string;

  @Prop({ default: true })
  isToolbarIcon!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop()
  tooltip!: string;

  @Prop({ default: [] })
  selectionOptions!: Array<T>;

  @Prop()
  getOptionName!: (value: T) => string;

  @Prop()
  getOptionKeyCallback?: (value: T) => string;

  getOptionKey(value: T) {
    if (this.getOptionKeyCallback) {
      return this.getOptionKeyCallback(value);
    } else {
      value;
    }
  }

  @Model("valueChanged")
  selectedValue!: T;

  get selectedValues() {
    const keySelected = this.getKey(this.selectedValue);
    return [keySelected];
  }

  selectOption(value: T) {
    this.$emit("valueChanged", value);
  }

  getKey(value: T) {
    return this.getOptionKeyCallback ? this.getOptionKeyCallback(value) : value;
  }

  get style() {
    const hasSelectedFirstOption =
      this.getKey(this.selectionOptions[0]) == this.getKey(this.selectedValue);

    return hasSelectedFirstOption
      ? ""
      : this.isToolbarIcon
        ? `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`
        : `background-color: ${themed(COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND, COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND_DARK)}`;
  }
}
